module.exports = __webpack_public_path__ + "assets/img/free_21.cd5b8651.png";